var src = document.querySelector("[src*=\"bundle.\"]").getAttribute("src");
__webpack_public_path__ = src.substr(0, src.lastIndexOf("/") + 1);

require("babel-polyfill");
require("./js/polyfills")();

var $ = window.jQuery = window.$ = require("jquery");

window.updateCart  = require("./js/modules/updateCart");
window.popUpInit   = require("./js/modules/popUpInit");
window.inputMask   = require("./js/modules/inputMask");
window.kitsInit   = require("./js/modules/kitsInit");

require("./js/modules/photoSwipe");
require("./js/modules/jquery.cookie/jquery.cookie.js");
require('./js/modules/form-grecaptcha')();
require('./js/modules/cookie-info')();


var initCustomWidgets = window.initCustomWidgets = function () {
	window.popUpInit();
	window.inputMask();
	require("./js/modules/clipboardInit")();
	require("./js/modules/menuInit")();
	require("./js/modules/bonusesInit")();
	require("./js/modules/asideInit")();
	require("./js/modules/catalogViewInit")();
	require("./js/modules/compareInit")();
	require("./js/modules/cardProductInit")();
	require("./js/modules/similarProductsInit")();
	require("./js/modules/sliderRangeInit")();
	require("./js/modules/slickCarouselInit")();
	require("./js/modules/formValidationInit")();
	require("./js/modules/spinnerInit")();
	require("./js/modules/passwordResetInit")();
	require("./js/modules/bonusesInit")();
	require("./js/modules/menuCatalogInit")();
	require("./js/modules/promoInit")();
	window.kitsInit();
	require("./js/modules/formDropDownInit")();
	require("./js/modules/scrollingToAnchorInit")();
	require("./js/modules/responsiveTableInit")();
	require("./js/modules/addRemoveRequiredInit")();
	require("./js/modules/formChangeDataInit")();
	require("./js/modules/collapseInit")();
	require("./js/modules/jqueryBarRatingInit")();
	require("./js/modules/scrollToAuthMobileInit")();
	require("./js/modules/filterItemSmartBarInit")();
	require("./js/modules/footerStickyInit")();
	require("./js/modules/filterFlyInit")();
	require("./js/modules/toggleBoxInit")();
};

$(initCustomWidgets);
$(window).on("resize.initCustomWidgets", initCustomWidgets);

require("./styles-entry");



/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/entry.js
 **/